// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__7MyEy"};